import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Work from "@/pages/Work";
import CaseStudy from "@/pages/CaseStudy";
import Category from "@/pages/Category";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import ProjectsAdmin from "@/pages/admin/ProjectsAdmin";
import ProjectEditor from "@/pages/admin/ProjectEditor";
import SiteImages from "@/pages/admin/SiteImages";
import TextsAdmin from "@/pages/admin/TextsAdmin";
import ClientsAdmin from "@/pages/admin/ClientsAdmin";
import ContactsInbox from "@/pages/admin/ContactsInbox";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#26292E] flex items-center justify-center">
        <p className="text-xs font-mono tracking-[0.3em] text-fog">CARICAMENTO…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

const Shell = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <div className="min-h-screen bg-night text-bone font-sans antialiased">
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/work" element={<Work />} />
        <Route path="/work/:slug" element={<CaseStudy />} />
        <Route path="/product" element={<Category key="product" category="product" />} />
        <Route path="/architecture" element={<Category key="architecture" category="architecture" />} />
        <Route path="/food" element={<Category key="food" category="food" />} />
        <Route path="/motion-ai" element={<Category key="motion-ai" category="motion-ai" />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
          <Route index element={<ProjectsAdmin />} />
          <Route path="progetti/nuovo" element={<ProjectEditor key="new" />} />
          <Route path="progetti/:slug" element={<ProjectEditor key="edit" />} />
          <Route path="immagini" element={<SiteImages />} />
          <Route path="testi" element={<TextsAdmin />} />
          <Route path="clienti" element={<ClientsAdmin />} />
          <Route path="richieste" element={<ContactsInbox />} />
        </Route>
        <Route path="*" element={<Home />} />
      </Routes>
      {!isAdmin && <Footer />}
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Shell />
          <Toaster position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
